import { createWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_ITEMS } from "../queries/useQueryWorkItems";

export const useMutationCreateWorkItem = () =>
  useWSMutation<
    Awaited<ReturnType<typeof createWorkItem>>,
    WSServiceError,
    Parameters<typeof createWorkItem>[0]
  >(createWorkItem, {
    awaitDependencies: [QUERY_WORK_ITEMS]
  });
